<template>
  <div
    class="modal_wrapper active"
    @click="closeCustomWidgetModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <div class="modal_header">
        <h3 class="tw-text-neutral-900 tw-text-2xl">
          {{ editMyWidget ? 'Edit' : 'Create' }} Custom Widget
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeCustomWidgetModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>
      <div class="section_modal_content white_box flex edit_section_modal mb_16">
        <div class="content">
          <custom-input
            v-model="widget.heading"
            :validation-errors="errors.heading"
            label="Widget heading"
            placeholder="Enter a name for the widget"
            width="full"
          />

          <custom-textarea
            v-model="widget.code"
            :html-input="true"
            :validation-errors="errors.code"
            label="Widget content ( HTML )"
            placeholder="Add your html code here"
            width="full"
          />
        </div>
      </div>
      <div class="section_modal_footer">
        <button
          v-if="editMyWidget"
          class="btn btn_md with_icon delete_btn"
          @click="deleteWidget()"
        >
          <svg
            fill="none"
            height="14"
            viewBox="0 0 14 14"
            width="14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8123 3.0625L2.18726 3.06251"
              stroke="#F34F4F"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M5.6875 5.6875V9.1875"
              stroke="#F34F4F"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
            <path
              d="M8.3125 5.6875V9.1875"
              stroke="#F34F4F"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
            <path
              d="M10.9373 3.0625V11.375C10.9373 11.491 10.8912 11.6023 10.8091 11.6844C10.7271 11.7664 10.6158 11.8125 10.4998 11.8125H3.49976C3.38372 11.8125 3.27244 11.7664 3.1904 11.6844C3.10835 11.6023 3.06226 11.491 3.06226 11.375V3.0625"
              stroke="#F34F4F"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
            <path
              d="M9.1875 3.0625V2.1875C9.1875 1.95544 9.09531 1.73288 8.93122 1.56878C8.76712 1.40469 8.54456 1.3125 8.3125 1.3125H5.6875C5.45544 1.3125 5.23288 1.40469 5.06878 1.56878C4.90469 1.73288 4.8125 1.95544 4.8125 2.1875V3.0625"
              stroke="#F34F4F"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </svg>
          <span>Delete</span>
        </button>
        <button
          v-if="!editMyWidget"
          class="btn btn_md primary_btn"
          @click="create()"
        >
          <span>
            <i
              v-if="saving"
              class="fa fa-btn fa-spinner fa-spin"
            />
            {{ saving ? 'Saving' : 'Save' }}
          </span>
        </button>
        <button
          v-else
          class="btn btn_md primary_btn"
          @click="update()"
        >
          <span>
            <i
              v-if="saving"
              class="fa fa-btn fa-spinner fa-spin"
            />
            {{ saving ? 'Updating' : 'Update' }}
          </span>
        </button>
        <button
          class="btn btn_md secondary_btn"
          @click="closeCustomWidgetModal()"
        >
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Swal from 'sweetalert2';
import {mapActions, mapState} from 'vuex';

import CustomInput from '../../../reports/components/global/forms/CustomInput.vue';
import CustomTextarea from '../../../reports/components/global/forms/CustomTextarea.vue';

export default {
  components: {
    CustomInput,
    CustomTextarea
  },
  data() {
    return {
      widget: {
        heading: null,
        code: null,
      },
      saving: false,
      errors: []
    }
  },
  computed: {
    ...mapState('dashboard', ['layout', 'customWidgets', 'editMyWidget']),
  },
  mounted() {
    if (this.editMyWidget) {
      let custom = _.find(this.customWidgets, {id: this.editMyWidget.custom_widget_id});
      this.widget = _.cloneDeep(custom);
    }
  },
  methods: {
    ...mapActions({
      closeCustomWidgetModal: 'dashboard/closeCustomWidgetModal',
      createCustomWidget: 'dashboard/createCustomWidget',
      updateCustomWidget: 'dashboard/updateCustomWidget',
      deleteCustomWidget: 'dashboard/deleteCustomWidget',
      openMyWidgetsModal: 'dashboard/openMyWidgetsModal',
      getCustomWidgets: 'dashboard/getCustomWidgets',
      removeWidget: 'dashboard/removeWidget',
      saveLayout: 'dashboard/saveLayout',
    }),
    create() {
      this.saving = true;

      this.createCustomWidget(this.widget)
          .then((data) => {
            this.saving = false;
            this.notifySanitized(data);
            this.closeCustomWidgetModal();
            this.openMyWidgetsModal();
          })
          .catch((response) => {
            this.errors = response.data.errors;
            this.saving = false;
          });
    },
    update() {
      this.saving = true;

      this.updateCustomWidget(this.widget)
          .then((data) => {
            this.saving = false;
            this.notifySanitized(data);
            this.closeCustomWidgetModal();
            this.getCustomWidgets();
            this.openMyWidgetsModal();

          })
          .catch((response) => {
            this.errors = response.data.errors;
            this.saving = false;
          });
    },
    /**
     * Tell the author when part of their widget was removed for security, so
     * the change does not present as their widget silently breaking.
     */
    notifySanitized(data) {
      if (!data?.warnings?.length) {
        return;
      }

      // Rendered as text, not html: the warnings quote the tags they removed
      // (<style>, <script>), which the browser would otherwise parse as markup.
      Swal.fire({
        title: 'Widget saved with changes',
        text: data.warnings.join('\n\n'),
        icon: 'info',
        confirmButtonColor: '#37B2A8',
        confirmButtonText: 'Got it',
      });
    },
    deleteWidget() {
      Swal.fire({
        title: 'Delete this custom widget?',
        text: "Are you sure? You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#37B2A8',
        cancelButtonColor: '#F34F4F',
        confirmButtonText: 'Yes, delete it!',
        showLoaderOnConfirm: true,
        backdrop: true,
        preConfirm: async () => {
          this.deleteIfExists(`${this.widget.heading}-${this.widget.id}`);
          await this.saveLayout();
          await this.deleteCustomWidget(this.widget.id).then(() => {
            this.closeCustomWidgetModal();
            this.openMyWidgetsModal();
          });
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: `Deleted successfully`,
            icon: 'success'
          });
          this.selected = [];
        }
      });
    },
    deleteIfExists(idPrefix) {
      let exists = false;
      if (this.layout) {
        _.forEach(this.layout, widget => {
          if (widget.id.includes(idPrefix)) {
            this.removeWidget(widget);
          }
        });
      }
      return exists;
    }
  },
}
</script>

<style scoped>
.section_modal_footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.section_modal_footer button {
  margin-bottom: 0;
  padding: .5rem 1.5rem;
}

.delete_btn {
  margin-right: auto;
}
</style>
